if ( typeof window !== 'undefined' ) {
  if ( !window['__REKA__'] ) {
    window['__REKA__'] = {};
  }
  
  window['__REKA__']["@rekajs/utils"] = "0.1.3";
}
  

import invariant from 'tiny-invariant';
export { default as invariant } from 'tiny-invariant';
import { customAlphabet } from 'nanoid';
export { default as debounce } from 'debounce';

var NANOID_ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
var nanoid = customAlphabet(NANOID_ALPHABET, 21);
var getRandomId = function () {
    return nanoid();
};

var safeObjKey = function (key) {
    var match = key.match(/(?:")?(.+)(?:")?/);
    invariant(match, 'Invalid object key');
    return match[1];
};
var capitalize = function (str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var omit = function (obj, keys) {
    return Object.keys(obj).reduce(function (accum, key) {
        if (!keys.includes(key)) {
            accum[key] = obj[key];
        }
        return accum;
    }, {});
};

export { capitalize, getRandomId, omit, safeObjKey };
